import { toast } from 'sonner';

import type { BulkJobKind } from '../utils/bulk-job-copy';
import { BulkJobProgressToast } from './bulk-job-progress-toast';

/** One toast per job (stable id): re-showing the same job updates it in place. */
export function showBulkJobToast(jobId: string, total: number, kind: BulkJobKind): void {
    toast.custom(
        (id) => (
            <BulkJobProgressToast
                jobId={jobId}
                total={total}
                kind={kind}
                onClose={() => toast.dismiss(id)}
            />
        ),
        { id: `contact-bulk-job:${jobId}`, duration: Infinity },
    );
}
